import * as Sentry from "@sentry/vue"

const MAX_SERIALIZED_LENGTH = 4000

const safeSerialize = (value) => {
  const seen = new WeakSet()
  try {
    const json = JSON.stringify(value, (key, val) => {
      if (typeof val === "object" && val !== null) {
        if (seen.has(val)) return "[Circular]"
        seen.add(val)
      }
      if (typeof val === "function") return `[Function ${val.name || "anonymous"}]`
      return val
    })
    if (json === undefined) return String(value)
    if (json.length > MAX_SERIALIZED_LENGTH) {
      return `${json.slice(0, MAX_SERIALIZED_LENGTH)}…`
    }
    return json
  } catch (error) {
    return String(value)
  }
}

export function reportError(error, context = {}) {
  const hasContext = context && Object.keys(context).length > 0
  const logPayload = hasContext ? { ...context, error } : { error }

  console.error("Captured error", logPayload)

  const client = Sentry.getClient()
  if (!client) {
    return
  }

  const isErrorInstance = error instanceof Error
  const serializedError = isErrorInstance ? null : safeSerialize(error)
  const sentryError = isErrorInstance
    ? error
    : new Error(typeof error === "string" ? error : `Non-Error thrown: ${serializedError}`)
  const extra = isErrorInstance
    ? context
    : {
        ...context,
        thrown: serializedError,
        thrownType: typeof error
      }

  if (hasContext) {
    Sentry.captureException(sentryError, { extra })
    return
  }

  if (isErrorInstance) {
    Sentry.captureException(sentryError)
    return
  }

  Sentry.captureException(sentryError, { extra })
}

export default reportError
